export default __webpack_public_path__ + "static/media/Excel_128x128.83721557.webp";